export enum KipoError {
  NOT_MATCH_ERROR = 'NOT_MATCH_ERROR',
  INTERNAL_ERROR_PAYPAL_STATUS_USER = 'INTERNAL_ERROR_PAYPAL_STATUS_USER',
  INTERNAL_ERROR_PAYPAL_COUNTRY_NOT_ALLOWED = 'INTERNAL_ERROR_PAYPAL_COUNTRY_NOT_ALLOWED',
}
